import { defineStore } from 'pinia'

interface IUserStore {
  username: string;
  role: string;
  avatar: string; 
}

const userKey = "USERKEY"

export const useStore = defineStore(userKey, {
  state(): IUserStore {
    return {
      username: localStorage.getItem('username') || "",
      role: (localStorage.getItem('role') || "user").toLowerCase(),
      avatar: localStorage.getItem('avatar') || "" 
    }
  },
  
  actions: {
    setUserInfo(info: { username: string; role: string; avatar: string }) {
      this.username = info.username
      this.role = (info.role || 'user').toLowerCase()
      this.avatar = info.avatar || ''
      
      // 持久化存储
      localStorage.setItem('username', info.username)
      localStorage.setItem('role', this.role)
      localStorage.setItem('avatar', info.avatar)
    },
    
    clearUser() {
      this.$reset()
      localStorage.removeItem('token')
      localStorage.removeItem('username')
      localStorage.removeItem('role')
      localStorage.removeItem('avatar')
    }
  },

  getters: {
    isSuperAdmin(): boolean {
      return this.role === 'superadmin'
    }
  }
})